import React from "react"

const HorizontalRuleFilter = () => {
    return (
        <hr
            style={{
                border: "1px solid #e7eaed",
            }}
        />
    )
}

HorizontalRuleFilter.propTypes = {}

export default HorizontalRuleFilter
